export const shipmentsNeedsFollowUpColumns = [
  "spec.project.number",
  "spec.purchaseOrder.number",
  "spec.customNumber",
  "spec.description",
  "spec.purchaseOrder.vendor.name",
  "id",
  "quantity",
  "spec.purchaseOrder.estimatedShipDate",
  "spec.purchaseOrder.estimatedDeliveryDate",
  "actualShipDate",
  "actualDeliveryDate",
  "needsFollowUp",
];
export const posNeedingAttentionColumns = [
  "project.number",
  "number",
  "vendor.name",
  "status",
  "estimatedShipDate",
  "estimatedDeliveryDate",
];
